<template>
  <div :class="['vue-tel-input-vuetify', 'align-start', wrapperClasses]">
    <div class="country-code">
      <v-select
        ref="countryInput"
        v-model="countryCode"
        :background-color="backgroundColor"
        :class="selectClasses"
        :color="color"
        :dark="dark"
        :dense="dense"
        :disabled="disabled"
        :filled="filled"
        :flat="flat"
        :height="inputHeight"
        :hide-details="hideDetails"
        :items="sortedCountries"
        :label="selectLabel"
        :light="light"
        :menu-props="menuProps"
        :outlined="outlined"
        :readonly="readonly"
        :rounded="rounded"
        :shaped="shaped"
        item-text="name"
        item-value="iso2"
        return-object
        @change="onChangeCountryCode"
      >
        <template #selection>
          <v-avatar
            class="rounded"
            height="22"
            size="24"
            tile
          >
            <v-img :src="`/img/flags/1x1/${activeCountry.iso2.toLowerCase()}.svg`" />
          </v-avatar>
        </template>
        <template #item="data">
          <v-avatar
            class="rounded mr-4"
            height="22"
            size="24"
            tile
          >
            <v-img :src="`/img/flags/1x1/${data.item.iso2.toLowerCase()}.svg`" />
          </v-avatar>
          <span>{{ data.item.name }} {{ `+${data.item.dialCode}` }}</span>
        </template>
      </v-select>
    </div>
    <v-text-field
      :id="inputId"
      ref="input"
      v-model="phone"
      :autocomplete="autocomplete"
      :autofocus="autofocus"
      :background-color="backgroundColor"
      :class="textFieldClasses"
      :clearable="clearable"
      :color="color"
      :dark="dark"
      :dense="dense"
      :disabled="disabled"
      :error="error"
      :error-messages="errorMessages"
      :filled="filled"
      :flat="flat"
      :full-width="fullWidth"
      :height="inputHeight"
      :hide-details="hideDetails"
      :hint="hint"
      :label="label"
      :light="light"
      :loader-height="loaderHeight"
      :loading="loading"
      :maxlength="maxLen"
      :messages="messages"
      :name="name"
      :outlined="outlined"
      :persistent-hint="persistentHint"
      :persistent-placeholder="persistentPlaceholder"
      :placeholder="placeholder"
      :prefix="prefix"
      :prepend-inner-icon="prependInnerIcon"
      :readonly="readonly"
      :required="required"
      :rounded="rounded"
      :rules="rules"
      :shaped="shaped"
      :single-line="singleLine"
      :success="success"
      :success-messages="successMessages"
      :suffix="suffix"
      :tabindex="inputOptions && inputOptions.tabindex ? inputOptions.tabindex : 0"
      :validate-on-blur="validateOnBlur"
      :value="value"
      type="tel"
      @blur="onBlur"
      @change="onChange"
      @click="onClick"
      @focus="onFocus"
      @input="onInput"
      @keydown="onKeyDown"
      @mousedown="onMouseDown"
      @mouseup="onMouseUp"
      @keyup.enter="onEnter"
      @keyup.space="onSpace"
    >
      <template #append>
        <slot name="append" />
      </template>
      <template #append-outer>
        <slot name="append-outer" />
      </template>
      <template #label>
        <slot name="label" />
      </template>
      <template #message="{key, message}">
        <slot
          name="message"
          v-bind="{key, message}"
        />
      </template>
      <template #prepend>
        <slot name="prepend" />
      </template>
      <template #prepend-inner>
        <slot name="prepend-inner" />
      </template>
      <template #progress>
        <slot name="progress" />
      </template>
    </v-text-field>
  </div>
</template>

<script>
import VueTelInputVuetifyMixin from '@/theme/default/components/common/VueTelInputVuetify/VueTelInputVuetify.js'

export default {
  name  : 'VueTelInputVuetify',
  mixins: [VueTelInputVuetifyMixin]
}
</script>

<style scoped src="@/theme/default/components/common/VueTelInputVuetify/VueTelInputVuetify.css"></style>

<style scoped>
</style>

<style lang="scss">

</style>
